import React from 'react'
import {PageSection} from "../../../components/PageSection";
import ngage from "../../../services/ngage";
import Button from "../../../components/Button";
import {useQuery} from "react-query";
import Spinner from "../../../components/Spinner";

// Helpers ----

function extractSecret(url: string): string {
  const urlObj = new URL(url);
  return urlObj.searchParams.get('secret') || '';
}

// Types ----

type TwoFactorAuthScanQRCodeProps = {
  onBack: () => void;
  onContinue: () => void;
}

// Component ----

function TwoFactorAuthScanQRCode({onBack, onContinue}: TwoFactorAuthScanQRCodeProps) {
  const { data: qrCode, isLoading } = useQuery('auth.twoFactorQrCode', ngage.auth.twoFactorCreateQRCode, { cacheTime: 0 });

  const qrCodeSecret = qrCode ? extractSecret(qrCode.url) : '---';

  return (
    <PageSection
      title='Scan QR Code'
    >
      <div className="flex flex-col gap-6 text-gray-900 text-sm">
        <p>Scan the QR code below or enter the secret key manually in to your authenticator app.</p>

        <div className='flex flex-col gap-4 items-center justify-center bg-gray-100 p-5'>
          <div className='flex items-center justify-center bg-white p-6 w-44 h-44'>
            {isLoading && <Spinner size={Spinner.sizes.SMALL} color={Spinner.colors.NEUTRAL} />}

            {(!isLoading && qrCode) && (
              <div className='[&>svg]:w-full [&>svg]:h-full' dangerouslySetInnerHTML={{ __html: qrCode.svg}}/>
            )}
          </div>

          <p className='text-lg font-medium text-gray-900'>{qrCodeSecret}</p>
        </div>

        <div className='flex gap-4 mt-4'>
          <Button
            color={Button.colors.PRIMARY}
            onClick={onContinue}
            disabled={!qrCode || isLoading}
          >
            Continue
          </Button>

          <Button
            color={Button.colors.WHITE}
            onClick={onBack}
          >
            Back
          </Button>
        </div>
      </div>
    </PageSection>
  );
}

export {TwoFactorAuthScanQRCode};